function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 42 42"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#46CAEF",
  width: "42",
  height: "42",
  rx: "4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.451 26.712c.063-1.652 1.96-3.178 3.129-4.354a9.275 9.275 0 10-13.041.112c1.169 1.148 2.961 2.73 3.017 4.389",
  fill: "#F1F4F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.726 28.196a1.47 1.47 0 00-1.47-1.47h-8.512a1.47 1.47 0 100 2.94 1.47 1.47 0 100 2.94h.7v1.841c0 .541.439.98.98.98h5.208a.98.98 0 00.98-.98v-1.834h.7a1.47 1.47 0 100-2.94 1.47 1.47 0 001.414-1.477z",
  fill: "#E54300"
}))));